import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    tbId = 0,
    search = '',
    filters = [],
    sorts = [],
    pi = 1,
    ps = 20,
    accessToken = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(`${URLS.das.utableData.getPage}/${tbId}`, {
        search,
        filters,
        sorts,
        pi,
        ps,
        accessToken,
    }, options);
    if (error) return { error, status };
    return content || {};
};
